/**
 * request_type, результаты которых хранятся в search slice.
 * Совпадает с server/shared/taskTypes.js, кроме типов с отдельными slice
 * (similar_brand, similar_analog, yandexImageSearch).
 */
export const SEARCH_REQUEST_TYPES = [
  'name',
  'image',
  'description_tz',
  'description_req',
  'description_wipo',
  'adress',
  'patentObl',
  'konstruktor',
  'description_elastic',
  'requests',
  'imageReq',
  'adressReq',
  'patentOblRequests',
  'konstruktor_req',
  'konstruktor_wipo',
  'wipoName',
  'wipoAdres',
  'wipoObl',
  'imageWipo',
  'getAiAnalitics',
  'check_search',
  'naming_search',
];

export const SEARCH_REQUEST_TYPES_SET = new Set(SEARCH_REQUEST_TYPES);

/** Типы с отдельными slice (brandName / analogGenerator), но тем же create_task на сервере */
export const SIMILAR_SEARCH_REQUEST_TYPES = ['similar_brand', 'similar_analog'];
export const SIMILAR_SEARCH_REQUEST_TYPES_SET = new Set(SIMILAR_SEARCH_REQUEST_TYPES);

export const CREATE_TASK_REQUEST_TYPES = [
  ...SEARCH_REQUEST_TYPES,
  ...SIMILAR_SEARCH_REQUEST_TYPES,
];
export const CREATE_TASK_REQUEST_TYPES_SET = new Set(CREATE_TASK_REQUEST_TYPES);

export function isSearchRequestType(requestType) {
  return SEARCH_REQUEST_TYPES_SET.has(requestType);
}

export function isSimilarSearchRequestType(requestType) {
  return SIMILAR_SEARCH_REQUEST_TYPES_SET.has(requestType);
}

export function isCreateTaskRequestType(requestType) {
  return CREATE_TASK_REQUEST_TYPES_SET.has(requestType);
}
